export const GROUP_ID = "GroupID";
export const GROUP_NAME = "GroupName";
export const GROUP_DESC = "Description";
export const CASE_MANAGER_ID = "CaseManagerID";
